import { AlertToast } from "@/helpers/alerts/AlertToast";
import Swal from "sweetalert2";

type Callback = (request: any) => void;

export class AlertRequest {
  public static success = () => {
    Swal.fire({
      title: "Saved",
      text: "Your changes were saved successful!",
      icon: "success",
    });
  };

  public static failed = () => {
    Swal.fire({
      title: "Error",
      text: "Your changes couldn't be saved!",
      icon: "error",
    });
  };

  public static warning = (text: string) => {
    Swal.fire({
      title: "Waring",
      text: text,
      icon: "warning",
    });
  };

  public static confirm = (
    callback: Callback,
    request: any,
    name: string | null = null,
  ) => {
    Swal.fire({
      title: `Are you sure you want to delete ${name ? name : request.Name}?`,
      text: "You won't be able to revert this!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#2e7d32",
      cancelButtonColor: "#af3f3b",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
          if (result.isConfirmed) {
            callback(request);
            AlertToast.success();
          }
        })
        .catch(() => {
          AlertToast.failed();
        });
  };

  public static confirmAsync = async (
    callback: Callback,
    request: any,
    name: string | null = null,
  ) => {
    const alert = await Swal.fire({
      title: `Are you sure you want to delete ${name ? name : request.Name}?`,
      text: "You won't be able to revert this!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#2e7d32",
      cancelButtonColor: "#af3f3b",
      confirmButtonText: "Yes, delete it!",
    });
    if (alert.isConfirmed) {
      await callback(request);
      await Swal.fire(
        "Deleted!",
        `${name ? name : request.Name} has been deleted.`,
        "success",
      );
    }
  };

  public static genericConfirmation = (callback: Callback, request: any) => {
    Swal.fire({
      title: `Are you sure you want to make this change?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#2e7d32",
      cancelButtonColor: "#af3f3b",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        callback(request);
        Swal.fire("Confirmed", ``, "success");

        return result.value;
      }
    });
  };

  public static delete = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2e7d32",
      cancelButtonColor: "#af3f3b",
      confirmButtonText: "Yes, delete it!",
    });
  };

  public static deleteConfirmed = (text: string) => {
    Swal.fire({
      title: "Deleted!",
      text: text,
      icon: "success",
    });
  };
}
